import React from "react";
import { Link } from "react-router-dom";
import withContentFallback from "../../utils/withContentFallback";
import { servicePreviewContent } from "../../constants/homePageContent";
import "./ServicePreview.css";
import OptimizedImage from "../shared/OptimizedImage";
import { services1 } from "../../assets/images";

const ServicePreview = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const { heading, text, services, buttonText, buttonLink } = content;

  return (
    <section className="services-preview section animate-on-scroll">
      <div className="container">
        <div className="services-preview-content">
          <div className="services-preview-text">
            <h2>{heading}</h2>
            <p>{text}</p>
            <ul className="services-list">
              {services &&
                services.map((service, index) => (
                  <li key={index}>{service}</li>
                ))}
            </ul>
            <Link to={buttonLink} className="btn btn-primary">
              {buttonText}
            </Link>
          </div>
          <div className="services-preview-image">
            <OptimizedImage
              {...services1}
              sizes="(max-width: 992px) 100vw, 560px"
              alt="Piano Service"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(ServicePreview, servicePreviewContent);
